
export const getCookie = (name: string): string | null => {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
};

export const setCookie = (name: string, value: string, days: number): void => {
    const d = new Date();
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;SameSite=Lax;expires=" + d.toUTCString();
};

export const hasRecaptchaCookie = () => getCookie("recaptcha-ca-e") != null;
